<template>
    <div>
        <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" ref="baseform" />
		</compWrapper>
		<compWrapper :title="$t('erp.channelbase.interface_info', { defaultValue: '接口信息' })" theme="primary">
            <compVendors :vendorsDetailData="vendorsData" ref="vendorform"></compVendors>
		</compWrapper>
        <compWrapper :title="$t('erp.channelbase.order_info', { defaultValue: '订单相关信息' })" theme="info">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getOrder" v-model="formData" />
		</compWrapper>
        <compWrapper :title="$t('erp.channelbase.shop_info', { defaultValue: '店铺注册信息' })" theme="info">
        <compFormEdit class="margin-top-15 margin-right-15" :formdata="getChannelInfo" v-model="formData" ref="channelInfoForm"></compFormEdit>
        </compWrapper>
		<compWrapper :title="$t('global.common.other_information', { defaultValue: '其他信息' })" theme="info">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getOther" v-model="formData" />
			<div class="text-right padding-right-20" v-show="type!='query'">
				<vButton theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: '确定' })}}</vButton>
				<vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
			</div>
		</compWrapper>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpQueryAccount, HttpSaveAccount, HttpGetVendorsTitleAndInit, HttpGetAccountInterface } from "@/service/managechannel/managechannel";
import { HttpActiveGetService} from '@/service/boss/b2corder'
import addchildTablelist from "./table.vue";
import compVendors from './vendors.vue'
export default {
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("../channelbase/log"),
        compVendors,
        addchildTablelist,
    },
    data(){
        return {
            type: this.$route.params.type,
			id:this.$route.query.id,
			query: false,
            formData:{
                orderOnlyShow:"N",
				isLineRelate:"N",
				saleType:'retailer',
				timeoutDays:3,
				lineRelateId:0,
				defaultManMadeShipment:0,
                isAccountPay:'0',
                issueAccountPay:'0',
				isOpenSFP:0,
				allowUpdate:'0',
            },
            vendorsData:{},
            styWidth : 210,
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
            flaglist:[],
			titlelist:[],
			initlist:[],
            sysdeliveries:[],
            oldtype:'',
            requireChannelInfo: false,
            validKey: ["name", "address", "city", "state", "country", "postcode"]
        }
    },
    created(){
        this.getNowFormatDate();
        // HttpActiveGetService().then(res=>{
        HttpNewActiveGetService({
            customerId: global.SYSID,
        }).then(res => {
            this.sysdeliveries = res.data.map(res=>{
                return {
                    value: res.code,
                    label: `${res.code}(${res.carrierServiceName})`
                }
            })
        },err=>{

        })
        
    },
    computed:{
         ...mapState("boss", ["accounts", "warehouseList",'products']),
		...mapGetters('common',['getMarketplaceId']),
        getBase(){
            return [
                {
                    label: this.$t('erp.channelbase.main_account_name', { defaultValue: "主账号名称" }),
                    key: "flag",
                    span: 12,
                    props:{
                        readonly:true
                    },
                    children:(h)=>{
                        return <vIcon
                        type="search"
                        center
                        slot="suffix"
                        style="padding:6px;pointer-events: initial;"
                        size="18"
                        nativeOnClick={this.handleModalplat.bind(this)}
                    />
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                        tip: `<div class="color-error">${this.$t('erp.channelbase.main_account_tip', { defaultValue: '若主账号已创建，新增子账号时则需做关联，否则会导致重复抓取数据' })}</div>`,
                    },
                },
                // {
                //     label: this.$t('erp.channelbase.channel_name', { defaultValue: "渠道名称" }),
                //     key: "title",
                //     props:{
                //         placeholder: this.$t('erp.channelbase.input_warning', { defaultValue: "只能输入数字、字母、下划线和横杠" }),
                //     },
                //     formItem:{
                //         labelWidth:this.styWidth,
                //         tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.save_tip', { defaultValue: '保存后会自动生成渠道标志和渠道标题，生成规则为渠道名称-销售国别英文缩写' })}</div>`,
                //     }
                // },
                {
                    label: this.$t('erp.channelbase.start_running_time', { defaultValue: "开始运营时间" }),
                    tag: 'vDatepicker',
                    key: 'beginSalesDate',
                    required:false,
                    props:{
                        format:'yy-mm-dd',
                        confirm:false,
                    },
                    formItem:{
                        labelWidth:this.styWidth,
                        tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.account_starting_runing_tip', { defaultValue: '账号的开始运营时间,接口会从开始运营时间自动获取订单，不填则默认当前时间' })}</div>`,
                    }
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: "备注" }),
                    key: "remark",
                    tag:'vTextarea',
                    required:false,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
            ]
        },
        getOrder(){
			const _this = this
			return [
			
			// query3
			{
				label: this.$t('erp.channelbase.order_tip', { defaultValue: "订单是否默认为展示订单" }),
				key: "orderOnlyShow",
				tag:"div",
				required: false,
				formItem:{
					labelWidth:this.styWidth,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.isordershow', { defaultValue: '订单是否默认为展示订单' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.orderOnlyShow}>
                                    <Radio label="Y">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="N">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			// query5
			{
				label: this.$t('erp.channelbase.not_connect_order', { defaultValue: "未关联项目的订单是否默认为展示单" }),
				key: "isLineRelate",
				tag:"div",
				required: false,
				formItem:{
					labelWidth:this.styWidth,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.isLineRelate', { defaultValue: '未关联项目的订单是否默认为展示单' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.isLineRelate}>
                                    <Radio label="Y">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="N">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			// query7
			{
				label: this.$t('erp.channelbase.is_channel_pay_cost', { defaultValue: "是否渠道支付运费" }),
				key: "isAccountPay",
				tag:"div",
				required: false,
                // on:{
                //     'on-change':(val)=>{
                //         // console.log(val)
                //         this.formData.issueAccountPay = val
                //     }
                // },
				formItem:{
					labelWidth:this.styWidth,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.isAccountPay', { defaultValue: '是否渠道支付运费' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.isAccountPay}>
                                    <Radio label="1">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="0">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			
            // query8
			{
				label: this.$t('erp.channelbase.bufa_is_channel_pay_cost', { defaultValue: "补发单是否渠道支付运费" }),
				key: "issueAccountPay",
				tag:"div",
				required: false,
				formItem:{
					labelWidth:this.styWidth,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.issueAccountPay', { defaultValue: '补发单是否渠道支付运费' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.issueAccountPay}>
                                    <Radio label="1">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="0">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			// query10
			{
				label: this.$t('erp.channelbase.is_allow_update_state', { defaultValue: "是否允许更新发货状态" }),
				key: "allowUpdate",
				tag:"div",
				required: false,
				formItem:{
					labelWidth:this.styWidth,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.allowUpdate', { defaultValue: '是否允许更新发货状态' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.allowUpdate}>
                                    <Radio label="1">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="0">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
            // query2
			{
				label: this.$t('erp.channelbase.send_allow_max_days', { defaultValue: "发货允许最大天数" }),
				key: "timeoutDays",
				required: false,
				formItem:{
					labelWidth:this.styWidth,
				},
                popper:this.$t('erp.channelbase.max_days_tip', { defaultValue: '超过最大天数订单会变为发货超时订单。若平台有发运允许最大天数，以平台为准' }),
			},
            // // query9
			{
				label: this.$t('erp.channelbase.carrier_upload_attach', { defaultValue: "哪些carrier需要上传附件" }),
				key: "bossShippingMethodCode",
				tag:'vSelect',
				required: false,
				options:this.sysdeliveries,
				props:{
					filterable:true,
					multiple:true,
				},
				formItem:{
					labelWidth:this.styWidth,
				},
            },

			];
		},
        getChannelInfo () {
            return [
                {
                    label: this.$t('global.common.name', { defaultValue: "名称" }),
                    key: "name",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    // required: this.handleRequire,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2border.addressone', { defaultValue: "地址1" }),
                    key: "address",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2border.addresstwo', { defaultValue: "地址2" }),
                    key: "address2",
                    tag: "vInput",
                    required: false,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2c.city', { defaultValue: "城市" }),
                    key: "city",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2c.state_province', { defaultValue: "州" }),
                    key: "state",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: "国家" }),
                    key: "country",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2c.zip_code', { defaultValue: "邮编" }),
                    key: "postcode",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                }
            ]
        },
		getOther(){
			return [
			{
				label: this.$t('erp.channelbase.account_incharge', { defaultValue: "账号负责人 " }),
				key: "manageUserTels",
				required:false,
				span:24,
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.account_exception_tip', { defaultValue: '账号发生异常会自动提醒账号的负责人，请填写负责人手机号，若有多个可用逗号隔开' })}</div>`,
					style:"width:50%"
				},
				props:{
					placeholder: this.$t('erp.channelbase.input_phone_incharge', { defaultValue: '请填写负责人手机号，若有多个可用逗号隔开' }),
				}
			},
			{
				label: this.$t('erp.channelbase.auth_date', { defaultValue: "授权日期" }),
				tag: 'vDatepicker',
				key: 'authorizationAt',
				// query:this.type == 'query',
				required:false,
				props:{
					format:'yy-mm-dd',
					confirm:false,
					placeholder:this.$t('erp.channelbase.auth_date_tip', { defaultValue: '授权到期前15天，自动提醒账号负责人' }),
				},
				formItem:{
					labelWidth:this.styWidth,
				}
            },
			];
		},
    },
    
    methods:{
        // 店铺注册信息必填逻辑
        handleRequire (value) {
            if (value) return this.$set(this, 'requireChannelInfo', true);
            if (!value) {
                let validResult = false;
                Object.keys(this.formData).map(key => {
                    this.validKey.map(item => {
                        if (key == item) {
                            if (this.formData[key]) {
                                validResult = true;
                            }
                        }
                    });
                });
                console.log(this.formData);
                console.log(validResult, this.validKey);
                this.$set(this, 'requireChannelInfo', validResult);
            }
        },
        getNowFormatDate(){
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
			this.formData.beginSalesDate = currentdate
			this.getTitle()
		},
        getTitle(){
			HttpGetVendorsTitleAndInit().then(res=>{
				this.flaglist = res.data.flag
				this.titlelist = res.data.title
				this.initlist = res.data.init
			},err=>{

			})
		},
        handleModalplat(){
            this.$VModal.info({
				title: this.$t('erp.channelbase.main_account_query', { defaultValue: "主账号查询" }),
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement("addchildTablelist",{
						props:{
							flaglist:this.flaglist,
							titlelist:this.titlelist,
							initlist:this.initlist,
						},
                        on:{
                            rows:(rows)=>{
								// console.log(rows)
								this.$set(this.formData,'flag',rows.flag)
                                this.getOneDetail(rows.id);
                                // this.$VModal.destroy();
							},
							cancel:()=>{
								this.$VModal.destroy();
							}
                        }
                    })
				}
			})
        },
        getOneDetail(id){
            HttpQueryAccount({
                id:id
            }).then(res=>{
                let onedata = res.data;
                this.oldtype = res.data.type;
                
                onedata.connectStr = JSON.parse(res.data.connectStr);

                this.vendorsData = onedata;
                this.$VModal.destroy();
            },err=>{

            })
        },
        async submit(){
            const valid = await this.$refs['baseform'].validate();
			if (!valid) return;
            
			let bool1 = await this.$refs.vendorform.validate();
			if (!bool1) return;
            
            
            if (this.requireChannelInfo) {
                let validChannel = true;
                let validCount = [];
                
                Object.keys(this.formData).map(key => {
                    this.validKey.map(item => {
                        if (key == item) {
                            console.log(key, this.formData[key]);
                            validCount.push(true);
                            if (!this.formData[key]) return validChannel = false;
                        }
                    });
                });
                if (validCount.length != this.validKey.length) validChannel = false;
                if (!validChannel) return this.$VMessage.warning(this.$t('global.common.fill_required'));
            }
            // // 匹配渠道名称
            // var titleReg = /^[A-Za-z0-9-_]+$/;
            // if(titleReg.test(this.formData.title)===false){
            //     this.$VMessage.error(this.$t('erp.channelbase.channel_name_warning', { defaultValue: '渠道名称输入不符合规范' }));
            //     return
            // }


            let vendorFlag = {...this.$refs.vendorform.vendorsData}
            let obj = {
				"product":"N",
				"order":"N",
                "report":"N",
                "finance":"N",
                "inbound":"N",
                "outbound":"N",
				"stock":"N"
			}
            let array = [];
            if(vendorFlag.new_flag1.length>0){
                vendorFlag.new_flag1.map((json)=>{
                        obj[json] = 'Y'
                })
                vendorFlag.new_flag1 = obj
            }else{
                vendorFlag.new_flag1 = obj
            }
            if(vendorFlag.new_flag2.length>0){
                vendorFlag.new_flag2.map((json)=>{
                        obj[json] = 'Y'
                })
                vendorFlag.new_flag2 = obj
            }else{
                vendorFlag.new_flag2 = obj
            }
            // console.log(this.vendorsData,'this.formData')
            if(vendorFlag.dropship == true || vendorFlag.disdropship == true){
                let vendordata1 = {
                    ...this.vendorsData,
                    ...this.formData,
                    type:'amazonvendords',
                    orgId:global.SYSID,
                    id:this.oldtype != 'amazonvendords'?'':this.vendorsData.id,
                    channelCategoryId:0,
                    countryRequest:[{
                        countryCode:vendorFlag.countryCode,
                        connectStr:JSON.stringify({
                            countryCode:vendorFlag.countryCode,
                            dropship:vendorFlag.dropship || vendorFlag.disdropship,
                            sellingPartyId:vendorFlag.disdropship == true ? '' : vendorFlag.sellingPartyId,
                            IsLabeled:vendorFlag.IsLabeled,
                            new_flag:vendorFlag.new_flag1
                        })
                    }],
                }
                // console.log(vendordata1,'datadata',copynewFlag)
                array.push(vendordata1)
            }
            if(vendorFlag.po == true || vendorFlag.dispo == true){
                let vendordata2 = {
                    ...this.vendorsData,
                    ...this.formData,
                    accountInit:this.vendorsData.accountInit,
                    type:'amazonvendor',
                    orgId:global.SYSID,
                    id:this.oldtype != 'amazonvendor'?'':this.vendorsData.id,
                    channelCategoryId:0,
                    countryRequest:[{
                        countryCode:vendorFlag.countryCode,
                        connectStr:JSON.stringify({
                            countryCode:vendorFlag.countryCode,
                            po:vendorFlag.po || vendorFlag.dispo,
                            new_flag:vendorFlag.new_flag2
                        })
                    }]
                    
                }
                // console.log(vendordata2,'datadata',copynewFlag)
                array.push(vendordata2)
            }
            HttpSaveAccount({
                list:array,
            }).then(res=>{
                this.submitAuthor()
                this.$VMessage.success(res.message);
                this.$router.push({ name: "channelBase" })
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(res=>{
                this.loading = false
            })

        },
        cancel(){
            this.$router.push({ name: "channelBase" })
        },
        submitAuthor(){
            HttpGetAccountInterface({
                channelFlag: this.formData.flag,type:this.formData.type
            }).then(res=>{
                if(res.message){
                    window.open(res.message, '_blank');
                }else{
                    this.$VMessage.error({
                        content:this.$t('erp.channelbase.accountinterface_tips', { defaultValue: '此平台暂不支持授权' }),
                        duration:10,
                        closeable:true,
                    })
                }
            },err=>{
                this.$VMessage.error({
                        content:err.message,
                        duration:10,
                        closeable:true,
                    })
            })
        }
    },
}
</script>
